"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnsContext = exports.DataGridContext = void 0;
var react_1 = __importStar(require("react"));
var hooks_1 = require("./hooks");
exports.DataGridContext = (0, react_1.createContext)({});
var useColumnsContext = function () { return (0, react_1.useContext)(exports.DataGridContext); };
exports.useColumnsContext = useColumnsContext;
var ColumnsProdvider = function (_a) {
    var children = _a.children, columns = _a.columns, _b = _a.columnsSetting, columnsSetting = _b === void 0 ? [] : _b, translate = _a.translate;
    var _c = (0, hooks_1.useColumns)(columns, columnsSetting), columnsState = _c.columnsState, setColumnsState = _c.setColumnsState;
    var value = (0, react_1.useMemo)(function () { return ({
        translate: translate,
        columnsState: columnsState,
        setColumnsState: setColumnsState,
    }); }, [translate, columnsState, setColumnsState]);
    return (react_1.default.createElement(exports.DataGridContext.Provider, { value: value }, children));
};
exports.default = ColumnsProdvider;
